import { createAction, props } from '@ngrx/store';

import { Scenery } from 'src/app/model/scenery';
import { SceneryAction } from 'src/app/model/scenery-action';
import { SceneryStep } from 'src/app/model/scenery-step';


export const getSceneries = createAction('GET_SCENERIES', props<{ siteId: number }>());
export const getSceneriesSuccess = createAction('GET_SCENERIES_SUCCESS', props<{ sceneries: Scenery[] }>());
export const getSceneriesFailed = createAction('GET_SCENERIES_FAILED', props<{ errorMessage: string }>());

export const getSteps = createAction('GET_STEPS', props<{ sceneryId?: number }>());
export const getStepsSuccess = createAction('GET_STEPS_SUCCESS', props<{ steps: SceneryStep[] }>());
export const getStepsFailed = createAction('GET_STEPS_FAILED', props<{ errorMessage: string }>());

export const getActions = createAction('GET_ACTIONS', props<{ stepId?: number }>());
export const getActionsSuccess = createAction('GET_ACTIONS_SUCCESS', props<{ actions: SceneryAction[] }>());
export const getActionsFailed = createAction('GET_ACTIONS_FAILED', props<{ errorMessage: string }>());

export const resetSceneryDialog = createAction('RESET_SCENERY_DIALOG');
export const addScenery = createAction('ADD_SCENERY', props<{ scenery: Scenery }>());
export const addScenerySuccess = createAction('ADD_SCENERY_SUCCESS', props<{
    message: string;
    scenery: Scenery;
}>());
export const addSceneryFailed = createAction('ADD_SCENERY_FAILED', props<{ errorMessage: string }>());

export const editScenery = createAction('EDIT_SCENERY', props<{ scenery: Scenery }>());
export const editScenerySuccess = createAction('EDIT_SCENERY_SUCCESS', props<{
    message: string;
    scenery: Scenery;
}>());
export const editSceneryFailed = createAction('EDIT_SCENERY_FAILED', props<{ errorMessage: string }>());

export const executeScenery = createAction('EXECUTE_SCENERY', props<{ id: number }>());
export const executeScenerySuccess = createAction('EXECUTE_SCENERY_SUCCESS', props<{
    message: string;
    sceneryId: number;
}>());
export const executeSceneryFailed = createAction('EXECUTE_SCENERY_FAILED', props<{ errorMessage: string }>());

export const deleteScenery = createAction('DELETE_SCENERY', props<{ sceneryId: number }>());
export const deleteScenerySuccess = createAction('DELETE_SCENERY_SUCCESS', props<{
    message: string;
    sceneryId: number;
}>());
export const deleteSceneryFailed = createAction('DELETE_SCENERY_FAILED', props<{ errorMessage: string }>());

export const resetStepDialog = createAction('RESET_STEP_DIALOG');
export const addStep = createAction('ADD_STEP', props<{ step: SceneryStep; action: SceneryAction }>());
export const addStepSuccess = createAction('ADD_STEP_SUCCESS', props<{ message: string; step: SceneryStep; action: SceneryAction }>());
export const addStepFailed = createAction('ADD_STEP_FAILED', props<{ errorMessage: string }>());

export const editStep = createAction('EDIT_STEP', props<{ step: SceneryStep; action: SceneryAction }>());
export const editStepSuccess = createAction('EDIT_STEP_SUCCESS', props<{ message: string; step: SceneryStep; action: SceneryAction }>());
export const editStepFailed = createAction('EDIT_STEP_FAILED', props<{ errorMessage: string }>());

export const deleteStep = createAction('DELETE_STEP', props<{ stepId: number }>());
export const deleteStepSuccess = createAction('DELETE_STEP_SUCCESS', props<{ message: string; stepId: number }>());
export const deleteStepFailed = createAction('DELETE_STEP_FAILED', props<{ errorMessage: string }>());

export const addAction = createAction('ADD_ACTION', props<{ action: SceneryAction }>());
export const addActionSuccess = createAction('ADD_ACTION_SUCCESS', props<{ action: SceneryAction }>());
export const addActionFailed = createAction('ADD_ACTION_FAILED', props<{ errorMessage: string }>());

export const editAction = createAction('EDIT_ACTION', props<{ action: SceneryAction }>());
export const editActionSuccess = createAction('EDIT_ACTION_SUCCESS', props<{ action: SceneryAction }>());
export const editActionFailed = createAction('EDIT_ACTION_FAILED', props<{ errorMessage: string }>());

export const reorderSteps = createAction('REORDER_STEPS', props<{ steps: SceneryStep[] }>());
export const reorderStepsSuccess = createAction('REORDER_STEPS_SUCCESS', props<{ steps: SceneryStep[] }>());
export const reorderStepsFailed = createAction('REORDER_STEPS_FAILED', props<{ errorMessage: string }>());
